import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  SWAL_SETTINGS,
  showFilterlist,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import {
  List,
  Status,
  Delete,
  ApproveAstrologerStatus,
  ChangeAstrologerPassword,
  SetInstantPrice,
  UpdateAiFreeStatus,
  UpdateTopStatus,
  UpdatePujaSortOrder,
} from "../../services/aiastrologer.services";
import { useFormik } from "formik";
import { Button, Modal } from "rsuite";

const AstrologerUserTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("AI Astrologer"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

  // --- STATE FOR PASSWORD MODAL (only need visibility and current ID now) ---
  const [showPassModal, setShowPassModal] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);

  const [idsToMarkFree, setIdsToMarkFree] = useState([]);
  const [idsToRemoveFree, setIdsToRemoveFree] = useState([]);
  // --------------------------------------------------------------------------

  const isRowFree = (row) => {
    const v = row?.is_free;
    if (v === true || v === 1 || v === "1") return true;
    if (typeof v === "string" && v.toLowerCase() === "true") return true;
    return false;
  };

  // --- FORMIK SETUP ---
  const formik = useFormik({
    initialValues: {
      new_password: '',
      confirm_new_password: ''
    },
    validate: (values) => {
      const errors = {};
      if (values.new_password.length < 6) {
        errors.new_password = t("Password must be at least 6 characters long");
      }
      if (values.new_password !== values.confirm_new_password) {
        errors.confirm_new_password = t("New password and confirm password do not match");
      }
      return errors;
    },
    onSubmit: (values, { setSubmitting, resetForm }) => {
      if (formik.errors.new_password || formik.errors.confirm_new_password) {
        setSubmitting(false);
        return Swal.fire({
          icon: "error",
          text: t("Please fix validation errors"),
          ...SWAL_SETTINGS,
        });
      }

      if (!currentUserId) {
        setSubmitting(false);
        return;
      }

      const formData = {
        o_id: currentUserId,
        new_password: values.new_password,
        confirm_new_password: values.confirm_new_password,
      };

      // API Call
      ChangeAstrologerPassword(formData)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            closePasswordModal();
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          console.log("Error changing password:", error);
          Swal.fire({
            icon: "error",
            text: t("An unexpected error occurred"),
            ...SWAL_SETTINGS,
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  });
  // ----------------------

  // --- HANDLER FOR MODAL OPEN/CLOSE ---
  const openPasswordModal = (userId) => {
    setCurrentUserId(userId);
    formik.resetForm(); // Reset Formik state when opening the modal
    setShowPassModal(true);
  };

  const closePasswordModal = () => {
    setShowPassModal(false);
  };
  // ------------------------------------

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        List(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            const astrologers =
              data?.data?.list && Array.isArray(data.data.list)
                ? data.data.list
                : [];

            setList(astrologers);
            setIdsToMarkFree([]);
            setIdsToRemoveFree([]);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/astrologer-management/ai-astrologer/view/${row.id}`
    );
  };

  const ChangeStatus = (data, Num) => {
    let ids = Array.isArray(data) ? data : [data];
    const payload = {
      o_id: ids,
      status: Num
    };
    Swal.fire({
      customClass: "swal-wide",
      title: t(`Are you sure you want to ${Num === 0 ? "block" : "unblock"} this astrolger ?`),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        Status(payload)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>", error);
          });
      }
    });
  };
  const ApproveAstrologer = (data) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t(`Are you sure you want to approve this Astrologer ?`),
      html: `
        <div style="text-align: left;">
          <p style="text-align: center; margin-bottom: 15px; font-size: 16px;">${t("Please enter screen name for this astrologer")}</p>
          <input id="swal-input-screen-name" class="swal2-input" placeholder="${t("Enter Screen Name")}" style="margin: 0 auto 20px auto; display: block; max-width: 100%;">
        </div>
      `,
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
      preConfirm: () => {
        const screenName = document.getElementById('swal-input-screen-name').value;

        if (!screenName || screenName.trim() === '') {
          Swal.showValidationMessage(t("You need to enter a screen name!"));
          return false;
        }

        return {
          screen_name: screenName.trim()
        };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          ...data,
          screen_name: result.value.screen_name
        }
        ApproveAstrologerStatus(payload)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>", error);
          });
      }
    });
  };

  const handleSetInstantPrice = (row) => {
    let instantPrice = null;
    if (row.consultation_prices && Array.isArray(row.consultation_prices)) {
      instantPrice = row.consultation_prices.find(p => p.type === 'instant');
    }

    const formatPrice = (price) => {
      const num = Number(price);
      return !isNaN(num) && num > 0 ? num : "";
    };

    const chatPriceINR = instantPrice ? formatPrice(instantPrice.per_minute_chat_price) : "";
    const chatPriceUSD = instantPrice ? formatPrice(instantPrice.per_minute_chat_price_usd) : "";
    const audioPriceINR = instantPrice ? formatPrice(instantPrice.per_minute_audio_price) : "";
    const audioPriceUSD = instantPrice ? formatPrice(instantPrice.per_minute_audio_price_usd) : "";
    
    let astrologerDiscount = row.discount !== null && row.discount !== undefined ? row.discount : "";

    Swal.fire({
      customClass: "swal-wide",
      title: t(`Set Instant Price / Minute`),
      html: `
        <div style="text-align: left; padding: 10px;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px; max-width: 100%; margin: 0 auto;">
             <div>
               <label style="display: block; font-weight: 500; font-size: 14px; margin-bottom: 5px;">${t("Chat Price (INR)")} <span style="color:red">*</span></label>
               <input id="swal-input-chat-inr" type="number" min="0" class="swal2-input" placeholder="0" value="${chatPriceINR}" style="margin: 0; width: 100%;" required>
             </div>
             <div>
               <label style="display: block; font-weight: 500; font-size: 14px; margin-bottom: 5px;">${t("Chat Price (USD)")} <span style="color:red">*</span></label>
               <input id="swal-input-chat-usd" type="number" min="0" class="swal2-input" placeholder="0" value="${chatPriceUSD}" style="margin: 0; width: 100%;" required>
             </div>

             <div>
               <label style="display: block; font-weight: 500; font-size: 14px; margin-bottom: 5px;">${t("Audio Price (INR)")} <span style="color:red">*</span></label>
               <input id="swal-input-audio-inr" type="number" min="0" class="swal2-input" placeholder="0" value="${audioPriceINR}" style="margin: 0; width: 100%;" required>
             </div>
             <div>
               <label style="display: block; font-weight: 500; font-size: 14px; margin-bottom: 5px;">${t("Audio Price (USD)")} <span style="color:red">*</span></label>
               <input id="swal-input-audio-usd" type="number" min="0" class="swal2-input" placeholder="0" value="${audioPriceUSD}" style="margin: 0; width: 100%;" required>
             </div>
          </div>
          
          <hr style="margin: 20px 0; border-top: 1px solid #ccc;"/>
          
          <div style="display: flex; gap: 15px; max-width: 100%; margin: 0 auto; justify-content: center;">
             <div style="flex: 1; max-width: 50%;">
               <label style="display: block; font-weight: 500; font-size: 14px; margin-bottom: 5px; text-align: center;">${t("Discount (%)")}</label>
               <input id="swal-input-discount" type="number" min="0" max="100" class="swal2-input" placeholder="Optional" value="${astrologerDiscount}" style="margin: 0; width: 100%;">
             </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_submit"),
      preConfirm: () => {
        const chat_price = document.getElementById('swal-input-chat-inr')?.value;
        const chat_price_usd = document.getElementById('swal-input-chat-usd')?.value;
        const audio_price = document.getElementById('swal-input-audio-inr')?.value;
        const audio_price_usd = document.getElementById('swal-input-audio-usd')?.value;
        const discount = document.getElementById('swal-input-discount')?.value;

        if (
          chat_price === "" || Number(chat_price) < 0 ||
          chat_price_usd === "" || Number(chat_price_usd) < 0 ||
          audio_price === "" || Number(audio_price) < 0 ||
          audio_price_usd === "" || Number(audio_price_usd) < 0
        ) {
          Swal.showValidationMessage(t("Please enter valid prices for Chat and Audio fields!"));
          return false;
        }

        if (discount !== undefined && discount !== null && discount !== "") {
          const discVal = Number(discount);
          if (discVal < 0 || discVal > 100) {
            Swal.showValidationMessage(
              t("Discount percentage must be between 0 and 100"),
            );
            return false;
          }
        }

        return {
          o_id: row.id,
          chat_price, chat_price_usd,
          audio_price, audio_price_usd,
          video_price: 0, video_price_usd: 0,
          commission: 0, discount
        };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        SetInstantPrice(result.value)
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>", error);
          });
      }
    });
  };



  function Deletefunction(data, email) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        let ids = Array.isArray(data) ? data : [data];
        formdata.append("o_id", JSON.stringify(ids))
        formdata.append("email", email)
        Delete({ o_id: data })
          .then((response) => {
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    if ($("#defaultstatus")[0]) $("#defaultstatus")[0].selectedIndex = 0;
    if ($("#defaultchartfilter")[0]) $("#defaultchartfilter")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/astrologer-management/ai-astrologer/${params.pgno}/edit/${row.id}`
    );
  };


  //     row.enrollment_details.days_in_expiry < 0 ?
  //       row.enrollment_details.plan_name
  //   ) : "None")

  const planName = (row) => {
    if (row && row.enrollment_details && row.enrollment_details.plan_name) {
      if (row.enrollment_details.days_in_expiry < 0) {
        return removeSpecialCharacter(`${capitalizeFirstLetter(row.enrollment_details.plan_name)}`) + `-Expired`;
      } else {
        return removeSpecialCharacter(capitalizeFirstLetter(row.enrollment_details.plan_name));
      }
    } else {
      return "None";
    }
  }

  const renewBtnShow = (row) => {
    return (
      row?.enrollment_details?.days_in_expiry && row?.enrollment_details?.days_in_expiry <= 5
    )
  }


  const isCheckboxChecked = (row) => {
    const id = row.id;
    if (idsToRemoveFree.includes(id)) return false;
    if (idsToMarkFree.includes(id)) return true;
    return isRowFree(row);
  };

  const handleFreeCheckbox = (row) => {
    const id = row.id;
    const checked = isCheckboxChecked(row);

    if (checked) {
      if (isRowFree(row)) {
        setIdsToRemoveFree((prev) =>
          prev.includes(id) ? prev : [...prev, id],
        );
      } else {
        setIdsToMarkFree((prev) => prev.filter((item) => item !== id));
      }
    } else if (isRowFree(row)) {
      setIdsToRemoveFree((prev) => prev.filter((item) => item !== id));
    } else {
      setIdsToMarkFree((prev) =>
        prev.includes(id) ? prev : [...prev, id],
      );
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setIdsToMarkFree(
        list.filter((row) => !isRowFree(row)).map((row) => row.id),
      );
      setIdsToRemoveFree([]);
    } else {
      setIdsToRemoveFree(
        list.filter((row) => isRowFree(row)).map((row) => row.id),
      );
      setIdsToMarkFree([]);
    }
  };

  const updateBulkFreeStatus = (isFree) => {
    const astrologerIds = isFree ? idsToMarkFree : idsToRemoveFree;

    if (!astrologerIds.length) {
      return Swal.fire({
        icon: "warning",
        text: isFree
          ? "Please select astrologers to mark as free"
          : "Please uncheck astrologers to remove free status",
        ...SWAL_SETTINGS,
      });
    }

    Swal.fire({
      title: isFree
        ? "Mark selected AI astrologers as Free?"
        : "Remove Free status from selected AI astrologers?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        UpdateAiFreeStatus({
          astrologer_ids: astrologerIds,
          is_free: isFree,
        })
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

              setIdsToMarkFree([]);
              setIdsToRemoveFree([]);
              setStatusUpdate((prev) => !prev);
            }
          })
          .catch(console.error);
      }
    });
  };

  const handleTopStatusUpdate = (row, newTopOrder) => {
    if (newTopOrder === undefined || newTopOrder === null || newTopOrder === "") return;

    UpdateTopStatus({ id: row.id, is_top: parseInt(newTopOrder) || 0 })
      .then((response) => {
        if (response.success || response.status) {
          setStatusUpdate((prev) => !prev);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
          setStatusUpdate((prev) => !prev);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          text: handleServerValidations(error),
          ...SWAL_SETTINGS,
        });
        setStatusUpdate((prev) => !prev);
      });
  };

  const handlePujaSortOrderUpdate = (row, newPujaSortOrder) => {
    if (newPujaSortOrder === undefined || newPujaSortOrder === null || newPujaSortOrder === "") return;

    UpdatePujaSortOrder({ id: row.id, puja_sort_order: parseInt(newPujaSortOrder) || 0 })
      .then((response) => {
        if (response.success || response.status) {
          setStatusUpdate((prev) => !prev);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
          setStatusUpdate((prev) => !prev);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          text: handleServerValidations(error),
          ...SWAL_SETTINGS,
        });
        setStatusUpdate((prev) => !prev);
      });
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {/* table section */}
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("AI Astrologers")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                {/* <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div> */}
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <div className="me-3">
                  <select
                    id="defaultchartfilter"
                    className="form-select filter_design"
                    value={search.chart_type || ""}
                    onChange={(e) => prepareSearch("chart_type", e.target.value)}
                    style={{ height: "40px", minWidth: "140px", borderRadius: "4px" }}
                  >
                    <option value="">{t("Select Chart")}</option>
                    <option value="SINGLE">{t("SINGLE")}</option>
                    <option value="DUAL">{t("DUAL")}</option>
                  </select>
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>

                <button
                  className="btn btn-success mr-2"
                  onClick={() => updateBulkFreeStatus(true)}
                  disabled={!idsToMarkFree.length}
                >
                  Mark Free ({idsToMarkFree.length})
                </button>

                <button
                  className="btn btn-danger mr-2"
                  onClick={() => updateBulkFreeStatus(false)}
                  disabled={!idsToRemoveFree.length}
                >
                  Remove Free ({idsToRemoveFree.length})
                </button>

                <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/astrologer-management/ai-astrologer/add`)
                  }
                >
                  {t("Create New Profile")}
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={
                          list.length > 0 &&
                          list.every((row) => isCheckboxChecked(row))
                        }
                        onChange={handleSelectAll}
                      />{" "}
                      Free Account
                    </th>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>
                    <th style={{ width: "50px" }}>{t("list_heading_profile")}</th>

                    <th>
                      <div className="sorting_column">
                        <span>{t("label_name")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="name"
                        />
                      </div>
                    </th>
                    <th>{t("Screen Name")}</th>
                    <th>Phone/Email</th>
                    <th>{t("Education")}</th>
                    <th>{t("Chart")}</th>


                    {/* <th className="">{t("label_plan_name")}</th>
                    <th className="">{t("label_expiry_date")}</th> */}

                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    {/* <th>Created By</th>
                    <th>Updated By</th> */}
                    <th>
                      <div className="sorting_column">
                        <span>Sort Order</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="sort_order"
                        />
                      </div>
                    </th>
                      <th>{t("Free Status")}</th>
                      <th>{t("Subscription Astrologer")}</th>
                      <th>
                        <div className="sorting_column">
                          <span>Top Order</span>
                          <Sorting
                            sort={sorting}
                            handleSort={handleSort}
                            column="is_top"
                          />
                        </div>
                      </th>
                      <th>
                        <div className="sorting_column">
                          <span>Puja Order</span>
                          <Sorting
                            sort={sorting}
                            handleSort={handleSort}
                            column="puja_sort_order"
                          />
                        </div>
                      </th>
                     <th className="status_head">{t("list_heading_status")}</th>
                    <th className="status_head">{t("Approval Status")}</th>
                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader && datalength > 0 ? (
                    <tr>
                      <td colSpan={17}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={isCheckboxChecked(row)}
                                  onChange={() => handleFreeCheckbox(row)}
                                />
                              </td>
                              <td>
                                {row ? (page - 1) * itemperpage + i + 1 : null}
                              </td>

                              <td>
                                {row?.profile_image ? (
                                  <div className="row_image">
                                    <img
                                      className="rounded"
                                      alt="profile"
                                      src={row?.profile_image}
                                    />
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              <td>
                                {row?.name ? (
                                  <div className="d-flex">
                                    {row?.name ? row.name : "N/A"}
                                  </div>
                                ) : (
                                  <div className="d-flex">N/A</div>
                                )}
                              </td>
                              <td>{row?.screen_name ? row.screen_name : "N/A"}</td>
                              <td>{row?.phone_number ? row.phone_number : row?.email ? row.email : "N/A"}</td>
                              <td>{row?.education ? row.education : "N/A"}</td>
                              <td>
                                {row?.chart_type || row?.chart ? (
                                  <span className="badge badge-info me-1">
                                    {row?.chart_type || row?.chart}
                                  </span>
                                ) : (
                                  "N/A"
                                )}
                              </td>
                              {/* <td>
                                {
                                  planName(row)
                                }
                              </td> */}

                              {/* <td>
                                {row.enrollment_details && row.enrollment_details.expiry_date
                                  ? formateDateWithMonth(row.enrollment_details.expiry_date)
                                  : "N/A"}
                              </td> */}

                              <td>
                                {row.createdAt
                                  ? formateDateWithMonth(row.createdAt)
                                  : "N/A"}
                              </td>

                              <td>{row?.sort_order || 0}</td>

                                <td>
                                {isCheckboxChecked(row) ? (
                                  <span className="badge badge-success">
                                    Free
                                  </span>
                                ) : (
                                  <span className="badge badge-secondary">
                                    Not Free
                                  </span>
                                )}
                              </td>

                              <td>
                                {row?.is_subscription_astrologer ? (
                                  <span className="badge badge-success">
                                    Yes
                                  </span>
                                ) : (
                                  <span className="badge badge-secondary">
                                    No
                                  </span>
                                )}
                              </td>

                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{ width: "80px" }}
                                  defaultValue={row?.is_top || 0}
                                  onBlur={(e) => {
                                    if (parseInt(e.target.value || 0) !== parseInt(row?.is_top || 0)) {
                                      handleTopStatusUpdate(row, e.target.value);
                                    }
                                  }}
                                />
                              </td>

                              <td>
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{ width: "80px" }}
                                  defaultValue={row?.puja_sort_order || 0}
                                  onBlur={(e) => {
                                    if (parseInt(e.target.value || 0) !== parseInt(row?.puja_sort_order || 0)) {
                                      handlePujaSortOrderUpdate(row, e.target.value);
                                    }
                                  }}
                                />
                              </td>


                              {/* <td>
                                <label className={"custom-switch"+ (row.status !== 1? " e_none" :"")}>
                                  <input disabled={row.status !== 1} type="checkbox" name="custom-switch-checkbox" className="custom-switch-input"
                                    checked={row.featured && row.status === 1 ? true : false}
                                    onChange={() => handleFeaturedChange(row.featured ? row.featured : false, i)} />
                                  <span className="custom-switch-indicator cp"></span>
                                </label>
                              </td> */}
                              <td>
                                {row.status === 1 ? (
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      ChangeStatus(row?.id, 0);
                                    }}
                                  >
                                    {t("Active")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn ripple btn-secondary"
                                    onClick={() => {
                                      ChangeStatus(row?.id, 1);
                                    }}
                                  >
                                    {t("Inactive")}
                                  </button>
                                )}
                              </td>
                              <td>
                                {row.approval_status === 1 ? (
                                  <button className="btn btn-success" disabled>
                                    {t("Approved")}
                                  </button>
                                ) : (
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => ApproveAstrologer({ o_id: row.id })}
                                  >
                                    {t("Approve")}
                                  </button>
                                )}
                              </td>
                              <td>
                                <div className="d-flex">
                                  <button
                                    className="btn ripple btn-main-primary signbtn"
                                    onClick={() => {
                                      viewfunction(row);
                                    }}
                                  >
                                    {t("btn_view")}
                                  </button>

                                  <button
                                    className="btn ripple btn-info mlAction"
                                    onClick={() => {
                                      handleSetInstantPrice(row);
                                    }}
                                  >
                                    {t("Set Price")}
                                  </button>

                                  <button
                                    className="btn ripple btn-success mlAction"
                                    onClick={() => {
                                      goToEdit(row);
                                    }}
                                  >
                                    {t("btn_edit")}
                                  </button>
                                  <button
                                    className="btn ripple btn-secondary mlAction"
                                    onClick={() => {
                                      Deletefunction(row?.id, row?.email);
                                    }}
                                  >
                                    {t("btn_delete")}
                                  </button>

                                  {/* <button
                                    className="btn ripple btn-info mlAction"
                                    onClick={() => {
                                      navigate(`/admin/astrologer-management/ai-astrologer/call-logs/${row.id}/1`);
                                    }}
                                  >
                                    {t("Call Logs")}
                                  </button> */}

                                  {row?.login_with === "email" && (
                                    <button
                                      className="btn ripple btn-warning mlAction"
                                      onClick={() => {
                                        openPasswordModal(row.id); // Open modal with user ID
                                      }}
                                    >
                                      {t("Change Password")}
                                    </button>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={17} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "AI Astrologer",
                    path: "/admin/astrologer-management/ai-astrologer/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      {/* --- PASSWORD CHANGE MODAL (Formik integrated) --- */}

      <Modal
        backdrop="static"
        keyboard={false}
        open={showPassModal}
        onClose={closePasswordModal}
        size="sm" // optional: small modal
      >
        <Modal.Header>
          <Modal.Title>{t("Change Password")}</Modal.Title>
        </Modal.Header>

        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="form-group mb-3">
              <label htmlFor="new_password">{t("New Password")}</label>
              <input
                type="text"
                className={`form-control ${formik.touched.new_password && formik.errors.new_password ? 'is-invalid' : ''}`}
                id="new_password"
                name="new_password"
                value={formik.values.new_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                minLength={6}
              />
              {formik.touched.new_password && formik.errors.new_password ? (
                <div className="invalid-feedback">{formik.errors.new_password}</div>
              ) : null}
            </div>

            <div className="form-group mb-3">
              <label htmlFor="confirm_new_password">{t("Confirm New Password")}</label>
              <input
                type="text"
                className={`form-control ${formik.touched.confirm_new_password && formik.errors.confirm_new_password ? 'is-invalid' : ''}`}
                id="confirm_new_password"
                name="confirm_new_password"
                value={formik.values.confirm_new_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                minLength={6}
              />
              {formik.touched.confirm_new_password && formik.errors.confirm_new_password ? (
                <div className="invalid-feedback">{formik.errors.confirm_new_password}</div>
              ) : null}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              onClick={closePasswordModal}
              appearance="subtle"
              disabled={formik.isSubmitting}
            >
              {t("btn_cancel")}
            </Button>
            <Button
              type="submit"
              appearance="primary"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? t("Loading...") : t("Save Changes")}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

    </>
  );
};

export default AstrologerUserTable;
